import { Box, Flex, Typography } from '@creditas-ui/react';
import { IconButton } from './DownloadApps.style';
import { AppleStore } from '../../../assets/icons/AppleStore';
import { GooglePlay } from '../../../assets/icons/GooglePlay';
import { envVars } from '../../../envVars';
import i18n from '../../../i18n';
import { dispatchAppleStoreEvent, dispatchGoogleStoreEvent } from '../../../utils/analyticsEvents';

const DownloadApps = (): JSX.Element => (
  <Box>
    <Typography color="neutral.60" variant="bodySmRegular">
      {i18n.t('header:download_app')}
    </Typography>

    <Flex marginTop="20px">
      <IconButton
        href={envVars.APP_STORE_URL}
        target="_blank"
        role="link"
        onClick={dispatchAppleStoreEvent}
      >
        <AppleStore data-testid="icon-apple" />
      </IconButton>
      <IconButton
        href={envVars.APP_STORE_URL}
        target="_blank"
        role="link"
        onClick={dispatchGoogleStoreEvent}
      >
        <GooglePlay data-testid="icon-google" />
      </IconButton>
    </Flex>
  </Box>
);

export { DownloadApps };
